const tabs1 = [
  {
    name: '南管音樂',
    autor: '黃瑤慧',
    path: 'observed_1',
  },
  {
    name: '南管音樂團體基礎概況調查分析',
    autor: '黃瑤慧',
    path: 'observed_16',
  },
  {
    name: '北管音樂',
    autor: '林雅琇',
    path: 'observed_2',
  },
  {
    name: '北管音樂團體基礎概況調查分析',
    autor: '林雅琇',
    path: 'observed_17',
  },
  {
    name: '福佬歌謠',
    autor: '李毓芳',
    path: 'observed_3',
  },
  {
    name: '客家音樂',
    autor: '林曉英',
    path: 'observed_4',
  },
  {
    name: '原住民音樂－賽夏族、阿美族、卑南族、雅美族、太魯閣族、撒奇萊雅族',
    autor: '孫俊彥',
    path: 'observed_5',
  },
  {
    name: '原住民音樂－泰雅族、鄒族、邵族、布農族、噶瑪蘭族、賽德克族',
    autor: '魏心怡',
    path: 'observed_6',
  },
  {
    name: '原住民音樂－排灣族、魯凱族、卡那卡那富族、拉阿魯哇族、平埔族',
    autor: '周明傑',
    path: 'observed_7',
  },
  // {
  //   name: '原住民音樂－邵族、布農族、噶瑪蘭族、賽德克族',
  //   autor: '魏心怡',
  //   path: 'observed_8',
  // },
  {
    name: '佛教、釋教音樂',
    autor: '何麗華',
    path: 'observed_9',
  },
  {
    name: '道教、法教音樂',
    autor: '楊秀娟',
    path: 'observed_10',
  },
  {
    name: '釋奠樂',
    autor: '蔡秉衡',
    path: 'observed_15',
  },
];
const tabs2 = [
  {
    name: '國樂',
    autor: '林心智',
    path: 'observed_11',
  },
  {
    name: '西樂及混合編制',
    autor: '連憲升、張羣禾',
    path: 'observed_12',
  },
];
const tabs3 = [
  {
    name: '流行音樂',
    autor: '徐玫玲',
    path: 'observed_13',
  },
];
const tabs4 = [
  {
    name: '跨界音樂與其他',
    autor: '陳慧珊',
    path: 'observed_14',
  },
];
export {
  tabs1, tabs2, tabs3, tabs4,
};
